export default __webpack_public_path__ + "static/media/17_SalutLesAmoureux.6890517b.mp3";